/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 11/10/2023
 */

import { Container } from "@mui/material";
import React from "react";
import ServicesIntro from "../Components/services/ServicesIntro";
import ServiceDetails from "../Components/services/ServiceDetails";
import { Helmet } from 'react-helmet';

const Services = () => {
  return (
    <>
      <Helmet>
        <title>
        Services - Adelaide - Housekeeping | Home Cleaning | Office Cleaning in Adelaide - Australia | Domestic house cleaning | Office cleaning | Garden cleaning | Y-DIY | offers
        </title>
          <link rel="canonical" href={`${process.env.prodUrl}/services`} key="canonical" />
      </Helmet>
      <Container style={{ maxWidth: "1500px" }}>
        <div style={{ marginTop: "20px", marginBottom: "10px" }}>
          <ServicesIntro />
        </div>
        <div style={{ marginTop: "2rem", marginBottom: "10px" }}>
          <ServiceDetails />
        </div>
      </Container>
    </>
  );
};

export default Services;
